<div class="box" #boxRef [ngStyle]="getStyle(style)" (clickOutside)="ocClickOut($event)">
  <div
    class="tags {{ required_class && 'dropdown-required' }}"
    [style.height.px]="height"
    [style.borderRadius.px]="borderRadius"
    [class.isHeight]="height ? true : false"
    (click)="showDropdown()">
    <span class="placeHolder" *ngIf="selected?.length === 0">{{ placeholder }}</span>
    <ng-container *ngFor="let item of selected; let i = index; trackBy: trackById">
      <div class="selected_one" [class.more]="selected?.length > 1" *ngIf="i === 0">
        <p class="cursor-pointer" (click)="openRecord(item)">{{ item.name }}</p>
        <span (click)="spliceItem(i)" class="pi pi-times-circle f-12"></span>
      </div>
    </ng-container>
    <i class="fas {{ isHide ? 'fa-sort-up' : 'fa-sort-down' }}"></i>
  </div>
  <div class="drop_box {{ selected?.length > 0 && 'h-370px' }}" [ngStyle]="escapeOverflow ? fixedStyle : null" *ngIf="isHide">
    <div class="flex_one">
      <div class="inpt" [class.mb-2]="!isMultiple">
        <input type="text" placeholder="Search" #myInput (input)="onInputChange($event.target.value)" class="_input-icon" />
        <span class="pi pi-search search f-14"></span>
      </div>
    </div>
    <p class="my-2 ml-2 cursor-pointer" (click)="createNewItem()" *ngIf="isCreateNew"><i class="pi pi-plus mr-2 f-10"></i>Create New</p>
    <ul>
      <li *ngIf="selected?.length > 0 && isMultiple" class="selected_count">{{ selected.length }} Selected item</li>
    </ul>
    <ul>
      <ng-container *ngIf="selected?.length > 0">
        <ng-container *ngFor="let item of selected; let i = index">
          <li
            (click)="addRemove(item)"
            [class._selected]="!isMultiple"
            [style.padding-left.px]="!isMultiple ? 15 : null"
            *ngIf="item?.name && item.isCheck"
            tooltipPosition="top"
            [pTooltip]="item?.name">
            <label class="checkbox style-d" *ngIf="isMultiple">
              <input type="checkbox" [(ngModel)]="item.isCheck" />
              <div class="checkbox__checkmark"></div>
            </label>
            <p>{{ item.name }}</p>
          </li>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="result_list?.length > 0">
        <ng-container *ngFor="let item of getUniqueItems(result_list, selected); let i = index">
          <li
            (click)="addRemove(item)"
            *ngIf="item?.name"
            [style.padding-left.px]="!isMultiple ? 15 : null"
            tooltipPosition="top"
            [pTooltip]="item?.name">
            <label class="checkbox style-d" *ngIf="isMultiple">
              <input type="checkbox" [(ngModel)]="item.isCheck" />
              <div class="checkbox__checkmark"></div>
            </label>
            <p [truncateLines]="2" [truncateText]="isEmail && item?.email ? item.name + ' (' + item?.email + ')' : item.name"></p>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
